// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__WZVmF","headline":"styles_headline__x1zMV","label":"styles_label__Ed9pS","tip":"styles_tip__2Zu1M","group":"styles_group__ykRww"};